import React from 'react';
import tinselIcon from '../../assets/images/icons/tinsel.webp';
import './TinselHeader.scss';

const TinselHeader = () => {
    return (
        <img src={tinselIcon} alt="Tinsel" className="tinsel-header" />
    );
};

export default TinselHeader;
